// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetWishListLinesApiParameter } from "@insite/client-framework/Services/WishListService";
import { DataViewState, setDataViewLoaded } from "@insite/client-framework/Store/Data/DataState";
import {
    BaseModel,
    CategoryModel,
    WishListLineCollectionModel,
    WishListLineModel,
} from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface WishListDetailsCategoryModel extends CategoryModel {
    wishListProducts: WishListLineModel[];
}

export interface MyListDetailsCategoryCategoryCollectionModel extends BaseModel {
    categories: WishListDetailsCategoryModel[];
}

export interface MyListDetailsCategoryState extends DataViewState<WishListDetailsCategoryModel> {
    showCategoryView: boolean;
}

const initialState: MyListDetailsCategoryState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    showCategoryView: false,
};

const reducer = {
    "Pages/MyListDetails/SetShowCategoryView": (
        draft: Draft<MyListDetailsCategoryState>,
        action: { showCategoryView: boolean },
    ) => {
        draft.showCategoryView = action.showCategoryView;
    },

    "Pages/MyListDetails/LoadWishListDetailsCategory": (
        draft: Draft<MyListDetailsCategoryState>,
        action: { parameter: GetWishListLinesApiParameter; wishListLines: WishListLineCollectionModel },
    ) => {
        const { parameter, wishListLines } = action;
        const categories = wishListLines.categories ?? [];
        const wishListProducts = wishListLines.wishListLines ?? [];
        const wishListDetailsCategories: WishListDetailsCategoryModel[] = categories.map(category => ({
            ...category,
            wishListProducts: wishListProducts.filter(product => product.properties?.categoryId === category.id),
        }));
        const wishListDetailsCategoryCollection: MyListDetailsCategoryCategoryCollectionModel = {
            categories: wishListDetailsCategories,
            uri: wishListLines.uri,
            properties: wishListLines.properties,
        };

        setDataViewLoaded(draft, parameter, wishListDetailsCategoryCollection, collection => collection.categories);
    },
};

const categoryReducer = createTypedReducerWithImmer(initialState, reducer);
export type MyListDetailsCategoryActions = Parameters<typeof categoryReducer>[1];
export default categoryReducer;
